module.exports = __webpack_public_path__ + "static/media/Undercarriage_2014_1012_edit.5c55107e.jpg";